import { render, staticRenderFns } from "./groupBuyList.vue?vue&type=template&id=b6c13560&scoped=true&"
import script from "./groupBuyList.vue?vue&type=script&lang=js&"
export * from "./groupBuyList.vue?vue&type=script&lang=js&"
import style0 from "./groupBuyList.vue?vue&type=style&index=0&id=b6c13560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c13560",
  null
  
)

export default component.exports